export const styles = {
  link: { textDecoration: 'none', padding: '10px 12px' },
};
